import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const cardBreakpoints = {
    320: {
        slidesPerView: 12 / 11, // 1 + 1/11 of a slide
        spaceBetween: 8,
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 8,
    },
    1280: {
        slidesPerView: 3,
        spaceBetween: 16,
    },
};

const imagesBreakpoints = {
    320: {
        slidesPerView: 12 / 11, // 1 + 1/11 of a slide
        spaceBetween: 8,
    },
    768: {
        slidesPerView: 1,
        spaceBetween: 8,
    },
    1024: {
        slidesPerView: 1,
        spaceBetween: 16,
    },
};

const getSwiperInitFn = (breakpoints) => (moduleEl) => {
    const swiperElm = moduleEl.querySelector('[data-js-swiper]');
    const indexWrapper = moduleEl.querySelector('[data-js-swiper-index]');

    return new Swiper(swiperElm, {
        lazyPreloadPrevNext: 2,
        modules: [Navigation, A11y],
        a11y: {
            enabled: true,
            scrollOnFocus: true,
        },
        navigation: {
            nextEl: moduleEl.querySelector('[data-js-swiper-next]'),
            prevEl: moduleEl.querySelector('[data-js-swiper-prev]'),
        },
        breakpoints,
        on: {
            activeIndexChange: ({ activeIndex }) => {
                if (indexWrapper) {
                    indexWrapper.textContent = activeIndex + 1;
                }
            },
        },
    });
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-js-module="images"]').forEach(getSwiperInitFn(imagesBreakpoints));
    document.querySelectorAll('[data-js-module="cards"]').forEach(getSwiperInitFn(cardBreakpoints));
});
